import { render } from "./OurSolutions.vue?vue&type=template&id=1282cd97&scoped=true"
import script from "./OurSolutions.vue?vue&type=script&lang=js"
export * from "./OurSolutions.vue?vue&type=script&lang=js"

import "./OurSolutions.vue?vue&type=style&index=0&id=1282cd97&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1282cd97"]])

export default __exports__